import { IComponentOptions } from "angular";
import templateUrl from "./employee-install-status.component.html";

export const EmployeeInstallStatusComponent: IComponentOptions = {
    bindings: {
        identity: "<"
    },
    templateUrl
};
